import { Box } from '@factorialco/deprecated-design-system'
import { F0Icon, F0Text } from '@factorialco/f0-react'
import { Calendar } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'
import type { HolidayGridEvent } from 'modules/shift_management/utils/TimeGridTable/transformEvents'

import type { EventCardSpec } from 'modules/shift_management/utils/TimeGridTable/resolveCard'

const HolidayCard: EventCardSpec<HolidayGridEvent> = {
  getAppearance: () => ({
    background: 'grey200',
    opacity: '1',
    border: undefined,
  }),
  render: (event) => (
    <Box flexDirection="column" gap="s4" paddingBottom="s6">
      <Box flexDirection="row" alignItems="center" gap="s4">
        <F0Icon icon={Calendar} size="sm" color="secondary" />
        <F0Text
          variant="label"
          content={event.holiday.halfDay ? `½ ${event.holiday.summary}` : event.holiday.summary}
          ellipsis
        />
      </Box>
      <Box paddingLeft="s4">
        <F0Text
          variant="label"
          content={i18n.t('shift_management.cells.bank_holiday.title')}
          ellipsis
        />
      </Box>
    </Box>
  ),
}

export { HolidayCard }
